import React, { useEffect } from "react";
import AlertData from "../../api/AlertData";
import { observer } from "mobx-react-lite";

export const AlertCenterHeader = observer(() => {
  let allowedCheckError = true;
  useEffect(() => {
    if (!allowedCheckError) return;
    allowedCheckError = false;
    AlertData.calcError();
  }, []);

  return (
    <div className="alert_error_counter_header_container">
      <span className="alert_error_counter_header_calc">
        {AlertData.counter_error}
      </span>
    </div>
  );
});
